<template>
    <div>
      <DashShellComponent
        :has-data="!!selectedProject"
        :tabs="invoiceTabs"
      >
        <!-- Slot for Selection Pane -->
        <template #selection-pane>
          <SelectionPane 
            :fileFormatter="formatProjects" 
            @selected="handleSelection" 
            @add-to-ledger="handleNewEntry" 
            @context-changed="getSelectedContext" 
          />
        </template>

        <!-- Slot for Header -->
        <template #header-content>
          <HeaderAndContent 
            :selectedInvoice="selectedProject" 
            :selectedClient="selectedClient" 
            :selectedQuote="selectedQuote" 
          />
        </template>
      </DashShellComponent>
    </div>
</template>

<script>
import axios from "@/plugins/axios"
import companiesJs from "@/plugins/companies"
import helpersJs from "@/plugins/helpers"
import ProjectDetails from "./ProjectDetails.vue"
import ProjectsDetailHeader from "./ProjectsDetailHeader.vue"
import AutoCompleteCrudAdvanced from "@/modules/CrudDatabases/AutoCompleteCrudAdvanced.vue"
import BillingTimer from '@/modules/CaseManager/BillingTimer.vue';
import BillingItemsTable from "@/modules/CaseManager/BillingItemsTable.vue";
import ClientManager from "@/modules/Clients/ClientManager.vue"
import WelcomeNotice from "@/components/General/WelcomeNotice.vue"
import InvoicePageHeader from "@/modules/InvoicesAndQuotes/InvoicePageHeader.vue"
import CaseDocumentsManager from "@/modules/CaseManager/CaseDocumentsManager.vue";
import CaseChronology from "@/modules/CaseManager/CaseChronology.vue";
import TrustAccountLedger from "@/modules/TrustAccount/TrustAccountLedger.vue"
import Quotations from "@/modules/InvoicesAndQuotes/Quotations.vue";
import SelectionPane from "@/components/General/SelectionPane.vue";
import HeaderAndContent from "@/components/General/HeaderAndContent.vue"
import DashShellComponent from "@/components/General/DashShellComponent.vue";

export default {
    computed:{
        isMobile(){
            return this.$store.getters.isMobile
        },
        getAuthenticated(){
            return this.$store.getters.getAuthenticated
        },
        getFileLabel(){
          return this.$store.getters.getFileLabel
        },
        getTertiaryColor(){
            return this.$store.getters.getTertiaryColor
        },
        getAccessToken(){
          return this.$store.getters.getAccessToken
        },
        getAppMode(){
          return this.$store.getters.getAppMode
        },
        getTrustAccLabel(){
          return this.$store.getters.getTrustAccLabel
        },
        invoiceTabs() {
            if (!this.selectedProject) return [];

            return [
              {
                label: '3. Billing & Expenses',
                mobileLabel: '3. Billing',
                icon: 'mdi-cash-register',
                component: BillingItemsTable,
                props: {
                  selectedInvoice: this.selectedProject,
                  itemLabel: 'Invoice',
                  referenceNumber: 'invoice_number'
                },
                on: {
                  'billing-added': this.refreshBillingEntries
                }
              },
              {
                label: `4. ${this.getTrustAccLabel} Account`,
                mobileLabel: '4. Account',
                icon: 'mdi-bank-outline',
                component: TrustAccountLedger,
                props: {
                  scope: 'case',
                  reference: this.selectedProject.reference_number
                }
              },
              {
                label: '5. Project Details',
                mobileLabel: '5. Project',
                icon: 'mdi-folder-account',
                component: ProjectDetails,
                props: {
                  selectedProject: this.selectedProject
                },
              },
              {
                label: '6. Activities & Tasks',
                mobileLabel: '6. Tasks',
                icon: 'mdi-format-list-checks',
                component: CaseChronology,
                props: {
                  caseData: this.selectedProject
                }
              },
              {
                label: '7. Documents',
                mobileLabel: '7. Docs',
                icon: 'mdi-file-document-multiple',
                component: CaseDocumentsManager,
                props: {
                  selectedCase: this.selectedProject,
                  emis: this.selectedProject.emis
                },
                on: {
                  'refresh-documents': this.refreshDocs
                }
              }
            ];
          }

    },
    components:{
    ProjectDetails,
    ProjectsDetailHeader,
    AutoCompleteCrudAdvanced,
    BillingTimer,
    ClientManager,
    WelcomeNotice,
    InvoicePageHeader,
    BillingItemsTable, CaseDocumentsManager, CaseChronology, TrustAccountLedger,
    Quotations,
    SelectionPane, HeaderAndContent,
    DashShellComponent
    },
    watch:{
        getAppMode:{
            handler(newVal){
                if(newVal === 'events'){
                    this.locationLabel = "Venue"
                }else{
                    this.locationLabel = "Site"
                }
            },
            immediate: true
        }
    },
    data: () => ({
        activeTab:null,
        locationLabel:"Site",
        selectedContext: null,
        selectedProject: null,
        selectedClient: null,
        selectedQuote: null,
        quotations: []
    }),
    async mounted(){
        this.initialiseComponent()
    },
    methods:{
        async initialiseComponent(){
          if(!this.getAuthenticated){
            return;
          }
            const userCompany = await companiesJs.getUserCompany()
            helpersJs.initialiseOrUpdateCompanyDataInStorage(null, userCompany)
            //await this.getAllProjects()
        },
        async getAllProjects(){
          //this.$store.commit("setLoader",true)
          const response = await axios.getData("/auth/get-all-projects",this.getAccessToken)
          //this.$store.commit("setLoader",false)
          if(response && response.status === 'success'){
            this.$store.commit('setAllProjects',response.projects)
          }
          
        },
        getSelectedContext(){
          this.selectedProject = null
          this.selectedClient = null
          this.selectedQuote = null
        },
        handleSelection(selection){
          if(!selection) return;
          const category = selection.category
          const selectedItem = selection.data
          this.selectedContext = true;

            if(category === 'primary'){
              this.getSelectedProject(selectedItem)
            }else if(category === 'client'){
              this.getSelectedClient(selectedItem)
            }else{ //its a quote
              this.getSelectedQuote(selectedItem)
            }
        },
        getSelectedProject(service){
            this.selectedClient = null;
            this.selectedQuote = null
            this.selectedProject = service;
        },
        formatQuotes({quotes}){
            if(!quotes || !quotes.length) return []
            const quotations = [];
            
            quotes.forEach(quote => {
                quotations.push({
                        ...quote,
                        name: `${quote.client?.name} | ${quote.quote_number}`
                    })
            });
            this.quotations = quotations
            return quotations;
        },
        getSelectedQuote(quote){
          this.selectedClient = null
          this.selectedProject = null
          this.selectedQuote = quote
        },
        getSelectedClient(selectedClient){
            this.selectedProject = null
            this.selectedQuote = null
            this.selectedClient = selectedClient
        },
        refreshDocs(docs){
          this.selectedProject.documents = docs
        },
          //not done
      getAndSetConvertedInvoice(convertedInvoice){
        this.selectedClient = null;
        this.selectedQuote = null;
        this.selectedProject = convertedInvoice;
      },
          //done
          refreshBillingEntries(billingEntries) {
          this.selectedProject.billingEntries = billingEntries
        },
        handleNewEntry(newEntry) {
        this.selectedProject.billingEntries.push(newEntry);
        
        this.$store.commit('setLoader',true)

        axios.postDataWithToken("/auth/save-or-update-case-billings",{
          internalRef:this.selectedProject.reference_number,
          invoiceNo: this.selectedProject.invoice_number,
          billingEntries: this.selectedProject.billingEntries
        },
        this.getAccessToken)
        .then(res => {
          this.$store.commit('setLoader',false)
          if(res && res.status == "success"){
            this.$toast.success("Billing entry added successfuly!",{duration:10000})
            this.selectedProject.billingEntries = res.billingEntries
          }else{
            this.$toast.error('Oops, something went wrong!',{duration:10000})
          }
        })
        },
        formatProjects({projects}){
                    if(!projects || !projects.length) return []
                    const formattedProjects = [];

                    projects.forEach(project => {
                        formattedProjects.push({
                            ...project,
                            name: `${project.client?.name} | ${project.reference_number}`
                        })
                    });
                    this.$store.commit('setAllProjects',formattedProjects)
                    return formattedProjects;
                },
            }
}
</script>